module.exports = __webpack_public_path__ + "static/media/icon-checkbox-off.79e1973d.svg";